
import { UseFormReturn } from "react-hook-form";
import { ComplaintFormValues } from "../types";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { useTextColorClass } from "@/components/ui/text-coloring";
import { SupportCaseFileUpload } from "../SupportCaseFileUpload";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

interface IncorrectDetailsSectionProps {
  form: UseFormReturn<ComplaintFormValues>;
  files: File[];
  onFilesChange: (files: File[]) => void;
}

export const IncorrectDetailsSection = ({
  form,
  files,
  onFilesChange,
}: IncorrectDetailsSectionProps) => {
  const { baseText, placeholderText, isDark } = useTextColorClass();
  const labels = supportLabels(getLanguage());
  
  return (
    <div className="space-y-3">
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel className={`${baseText} text-sm`}>
              {labels.incorrectDetailsLabel}
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder={labels.incorrectDetailsPlaceholder}
                className={`min-h-[80px] sm:min-h-[100px] ${isDark ? "bg-black/20 border-white/20 text-white" : "bg-white border-gray-200 text-black"} ${placeholderText} text-xs sm:text-sm py-1.5`}
                {...field}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <SupportCaseFileUpload
        files={files}
        onFilesChange={onFilesChange}
        title={labels.uploadSupportingDocuments}
      />
    </div>
  );
};
